
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/hooks/[[...slug]]",
      function () {
        return require("private-next-pages/docs/hooks/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/hooks/[[...slug]]"])
      });
    }
  